import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { InstrumentType } from '@zero/shared/util-models';
import { filter, map } from 'rxjs';
import { assetClassOverviewActions } from '../+state/asset-class-overview.actions';
import { assetClassOverviewFeature } from '../+state/asset-class-overview.reducer';

@Injectable({ providedIn: 'root' })
export class AssetClassOverviewFacade {
  readonly #store = inject(Store);
  readonly #customerStateFacade = inject(CustomerStateFacade);

  public readonly customerClassification$ = this.#customerStateFacade.customerBaseData$.pipe(
    filter((customerBaseData) => !!customerBaseData),
    map(({ customerClassification }) => customerClassification),
  );

  public readonly etfsByIndices$ = this.#store.select(assetClassOverviewFeature.selectEtfsByIndices);
  public readonly mostPopularEtfs$ = this.#store.select(assetClassOverviewFeature.selectMostPopularEtfs);
  public readonly mostPopularStocks$ = this.#store.select(assetClassOverviewFeature.selectMostPopularStocks);
  public readonly callMoneyAlternatives$ = this.#store.select(assetClassOverviewFeature.selectCallMoneyAlternatives);
  public readonly mostActiveAssets$ = this.#store.select(assetClassOverviewFeature.selectMostActiveAssets);
  public readonly winnerLoser$ = this.#store.select(assetClassOverviewFeature.selectWinnerLoser);

  public loadCustomerBaseData = () => this.#customerStateFacade.loadCustomerBaseData(true);
  public loadEtfsByIndices = () => this.#store.dispatch(assetClassOverviewActions.loadEtfsByIndices());
  public loadMostPopularEtfs = () => this.#store.dispatch(assetClassOverviewActions.loadMostPopularEtfs());
  public loadMostPopularStocks = () => this.#store.dispatch(assetClassOverviewActions.loadMostPopularStocks());
  public loadCallMoneyAlternatives = () => this.#store.dispatch(assetClassOverviewActions.loadCallMoneyAlternatives());
  public loadMostActiveAssets = (instrumentType: InstrumentType) =>
    this.#store.dispatch(assetClassOverviewActions.loadMostActiveAssets({ instrumentType }));
  public loadWinnerLoser = (instrumentType: InstrumentType) =>
    this.#store.dispatch(assetClassOverviewActions.loadWinnerLoser({ instrumentType }));
}
